import React from "react";
// import Chart from "react-google-charts";

function Token() {
  return (
    <>
      <div className="piechart">
        <center>
          <h2
            className="wow fadeInUp headings glitch heading"
            data-wow-delay=".75s"
          >
            Tokenization
          </h2>
        </center>


        {/* <div className="container">
          <div className="container-fluid" style={{width:"100%",margin:"0"}}>
            <div className="supply col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <p className="home_p">
                <strong className="strong_supply">Total Supply:</strong> 100,000,000
                $LITTLE
              </p>
            </div>
            <div className="supply col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <p className="blockchain home_p">
                <strong className="strong_supply">Blockchain:</strong> ERC-20
              </p>
            </div>
          </div>  
        </div>       */}


        <div className="token_heading">
          <p className="home_p">
            <strong className="strong_supply">Total Supply:</strong> 100,000,000
            $LITTLE
          </p>
          <p className="blockchain home_p">
            <strong className="strong_supply">Blockchain:</strong> ERC-20
          </p>
        </div>
        <div className="container pie_chart">
          <div className="row charts">
            <div className="col-xl-4 staking_list">
              <div className="row">
                <div className="supply col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <p className="list_para">Total supply</p>
                    <span className="supply_num home_p">100,000,000,000</span>
                </div>
                <div className="supply col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <p className="list_para">Staking</p>
                    <span className="supply_num home_p">700,000,000</span>
                </div>
                <div className="supply col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <p className="list_para">IPCO</p>
                    <span className="supply_num home_p">140,000,000</span>
                </div>
                <div className="supply col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <p className="list_para">Liquidity</p>
                    <span className="supply_num home_p">110,000,000</span>
                </div>
                <div className="supply col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <p className="list_para">Marketing</p>
                    <span className="supply_num home_p">40,000,000</span>
                </div>
                <div className="supply col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <p className="list_para">Team</p>
                    <span className="supply_num home_p">10,000,000</span>
                </div>
              </div>
              {/* <ul className="list_one">
                <li>
                  <div className="supply">
                    <p className="list_para">Total supply</p>
                    <span className="supply_num home_p">100,000,000</span>
                  </div>
                </li>
                <li>
                  <div className="staking">
                    <p className="list_para">Staking</p>
                    <span className="supply_num home_p">70,000,000</span>
                  </div>
                </li>
              </ul>

              <ul className="list_one">
                <li>
                  <div className="supply">
                    <p className="list_para">ICO</p>
                    <span className="supply_num home_p">14,000,000</span>
                  </div>
                </li>

                <li>
                  <div className="staking">
                    <p className="list_para">Liquidity</p>
                    <span className="supply_num home_p">10,000,000</span>
                  </div>
                </li>
              </ul>

              <ul className="list_one">
                <li>
                  <div className="supply">
                    <p className="list_para">Marketing</p>
                    <span className="supply_num home_p">4,000,000</span>
                  </div>
                </li>
                <li>
                  <div className="staking teams">
                    <p className="list_para">Team</p>
                    <span className="supply_num home_p">2,000,00</span>
                  </div>
                </li>
              </ul> */}
            </div>
            <div className="col-xl-5">
              <img className="chart-img" src={"images/LB_Logo1.png"} alt="chart" />
              {/* <Chart
                width={"100%"}
                height={"400px"}
                chartType="PieChart"
                // loader={<div>Loading Pie Chart</div>}
                data={[
                  ["Task", "Hours per Day"],
                  ["", 10.8],
                  ["", 1.9],
                  ["", 1.6],
                  ["", 3.7],
                  ["", 6],
                ]}
                options={{
                  // title: 'Tokenization',
                  is3D: false,
                  pieHole: 0.4,
                  legend: {
                    textStyle: { color: "black" },
                  },
                  backgroundColor: "#fff",
                  colors: [
                    "#3a3d62",
                    "#005133",
                    "#63982B",
                    "#5e6682",
                    "#4c5171",
                  ],
                }}
              /> */}
            </div>
            <div className="col-xl-3 token_lists">
              <ul className="option-list" id="list_1">
                <li>
                  <button className="option-btn"></button>
                </li>
                <li>
                  <p className="strong">Staking:</p>
                </li>
                <li className="number-list">70,000,000</li>
              </ul>

              <ul className="option-list" id="list_2">
                <li>
                  <button className="option-btn btn-2"></button>
                </li>
                <li>
                  {" "}
                  <p className="strong">Staking:</p>
                </li>
                <li>
                  <li className="number-list">70,000,000</li>
                </li>
              </ul>

              <ul className="option-list" id="list_2">
                <li>
                  <button className="option-btn btn-2"></button>
                </li>
                <li>
                  {" "}
                  <p className="strong">ICO:</p>
                </li>
                <li>
                  <li className="number-list">14,000,000</li>
                </li>
              </ul>
              <ul className="option-list" id="list_3">
                <li>
                  <button className="option-btn btn-3"></button>
                </li>
                <li>
                  {" "}
                  <p className="strong">Liquidity:</p>
                </li>
                <li>
                  <li className="number-list">10,000,000</li>
                </li>
              </ul>
              <ul className="option-list" id="list_3">
                <li>
                  <button className="option-btn btn-4"></button>
                </li>
                <li>
                  {" "}
                  <p className="strong">Marketing:</p>
                </li>
                <li>
                  <li className="number-list">4,000,000</li>
                </li>
              </ul>
              <ul className="option-list" id="list_3">
                <li>
                  <button className="option-btn btn-5"></button>
                </li>
                <li>
                  {" "}
                  <p className="strong">Team:</p>
                </li>
                <li>
                  <li className="number-list">2,000,000</li>
                </li>
              </ul>
            </div>
            <div className="price_list">
              <ul className="price-phrase">
                <li>
                  <button className="mint-btn effecthov home_token">
                    <span>Fixed price after NFT mint:</span> 0.05$
                  </button>
                </li>
                <li>
                  <button className="mint-btn effecthov home_token">
                    <span>IPCO Price phase 1:</span> 0.10$
                  </button>
                </li>
                <li>
                  <button className="mint-btn effecthov home_token">
                    <span>IPCO price phase 2:</span> 0.15$
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Token;
